<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :rowClick="rowClickCallBack"
    :persistenceKey="'goods-in-review-list'"
  />
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";

import TransactionListTemplate from "@/templates/transaction-list";
import { FeatureStorage } from "@/_services/storage";
import { GoodsInReviewService } from "@/_services/api/purchasing/goods-in-review.service";
import ColumnWidth from "@/_helpers/data-grid/ColumnWidth";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionListTemplate,
  },
  data() {
    return {};
  },
  computed: {
    setScreenConfig() {
      return {
        title: "Purchase Orders",
        ScreenName: "Purchase Orders - Received",
        selectedIndex: 2,
        tabs: [
          {
            text: "All",
            path: `/purchase-order`,
            applicationFeatureCode: "PurchaseOrder",
          },
          {
            text: "To Receive",
            path: `/goods-in`,
            applicationFeatureCode: "GoodsIn",
          },
          {
            text: "Received",
            path: `/goods-in-review`,
            applicationFeatureCode: "GoodsIn",
          },
          {
            text: "Invoiced",
            path: `/supplier-invoiced`,
            applicationFeatureCode: "SupplierInvoice",
          },
        ],

        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "GoodsInList",
              serverPaging: true,
              allowGrouping: false,
            },
            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No Goods In",
                message: "Get Started, Add a PO to Receive.",
              },
            },
          },

          toolbar: {
            search: false,
            columnChooser: true,
            export: false,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add Invoice",
                route: "/supplier-invoice/create",
                routeQuery: {
                  from: "goods-in-review",
                },
                clickAction: {},
                buttonLocation: "left",
              },
            ],
          },
          columns: [
            {
              screenField: "GoodsIn",
              gridDataField: "Code",
              sortOrder: "desc",
              sortIndex: 0,
              allowHiding: false,
              filterDataField: "Code",
              width: ColumnWidth.GoodsInCode.width,
              minWidth: ColumnWidth.GoodsInCode.minWidth,
              forceWidth: true,
            },
            {
              screenField: "Code",
              filterDataField: "Code",
              filterLabel: "Goods In",
              showInColumnChooser: false,
              visible: false,
              type: "Integer",
              filterIndex: 0,
              name: "GoodsInCode",
            },
            {
              screenField: "PurchaseOrder",
              gridDataField: "PurchaseOrderCode",
              type: "Integer",
              filterDataField: "PurchaseOrderCode",
              width: ColumnWidth.PurchaseOrderCode.width,
              minWidth: ColumnWidth.PurchaseOrderCode.minWidth,
              forceWidth: true,
              hyperlink: {
                url: "purchase-order-v2/review/__ID__",
                target: "_blank",
              },
            },
            {
              screenField: "Code",
              filterDataField: "PurchaseOrderCode",
              filterLabel: "Purchase Order",
              showInColumnChooser: false,
              visible: false,
              type: "Integer",
              filterIndex: 1,
            },
            {
              screenField: "Supplier",
              gridDataField: "SupplierCode",
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "SupplierName",
                  },
                ],
                secondary: [
                  {
                    dataField: "SupplierCode",
                  },
                ],
              },
              exportFields: [
                {
                  dataField: "SupplierCode",
                  label: "Supplier Code",
                },
                {
                  dataField: "SupplierName",
                  label: "Supplier Name",
                },
              ],
              filterDataField: "SupplierCode",
              filterIndex: 2,
            },
            {
              screenField: "SupplierRef",
              dataType: "string",
              type: "Text",
              filterIndex: 3,
            },
            {
              screenField: "DateIn",
              gridLabel: "Date",
              filterLabel: "Date",
              filterIndex: 5,
            },
            {
              screenField: "LineComment",
              gridLabel: "# Lines",
              dataField: "LineInfo",
              width: ColumnWidth.LineInfo.width,
              minWidth: ColumnWidth.LineInfo.minWidth,
            },
            {
              screenField: "DateReceived",
              gridLabel: "Date Received",
              filterLabel: "Date Received",
              filterIndex: 6,
            },
            {
              screenField: "OrderStatus",
              gridDataField: "FriendlyStatus",
              filterDataField: "FriendlyStatus",
              filterIndex: 4,
              dataSourceConfig: {
                data: ["Closed", "Invoiced", "Open", "Return", "Returned"],
              },
            },
            {
              screenField: "ProductAcct",
              visible: false,
              showInColumnChooser: false,
              filterIndex: 7,
              filterOperator: "contains",
              gridDataField: "ItemCodeList",
              filterDataField: "ItemCodeList",
            },
            {
              screenField: "GridRecordEmail",
              cssClass: "padding-7",
              ReferenceNoField: "Code",
            },
            {
              screenField: "GridRecordPDFView",
              cssClass: "padding-7",
            },
            {
              screenField: "GridRecordPrint",
              cssClass: "padding-7",
              ReferenceNoField: "Code",
            },
            {
              screenField: "GridRecordEllipsisMenu",
              cssClass: "padding-7",
              allowSearch: false,
              ellipsisMenu: {
                itemAction: (data) => {
                  return [
                    {
                      menuText: "Return",
                      data: data,
                      clickAction: this.toReturn,
                      disabled: !(
                        FeatureStorage.checkPermission(
                          "GoodsReturn",
                          "create",
                        ) && data.data.FriendlyStatus === "Open"
                      ),
                    },
                    {
                      menuText: "Invoice",
                      data: data,
                      clickAction: this.goToSupplierInvoice,
                      disabled: !(
                        data.data.FriendlyStatus === "Open" &&
                        FeatureStorage.checkPermission(
                          "SupplierInvoice",
                          "create",
                        )
                      ),
                    },
                    {
                      menuText: "Complete",
                      data: data,
                      clickAction: this.markAsComplete,
                      disabled: !(
                        FeatureStorage.checkPermission("GoodsIn", "create") &&
                        data.data.FriendlyStatus === "Open"
                      ),
                    },
                  ];
                },
                keyExpr: "menuText",
                displayExpr: "menuText",
              },
            },
          ],
        },
      };
    },
  },
  methods: {
    goToSupplierInvoice(e) {
      this.$router.push({
        path: "/supplier-invoice/create/" + e.PurchaseOrderCode,
        query: {
          from: "goods-in-review",
        },
      });
    },
    toReturn(e) {
      this.onRowClicked(
        { data: e },
        {
          view: this,
          page: "goods-return",
          mode: "edit",
          idProperty: "Code",
          query: {
            redirect: "/goods-in-review",
          },
        },
      );
    },
    async markAsComplete(e, grid) {
      const confirmed = await this.$confirm(
        "Are you sure you want to Complete this Goods In and reverse the Accrual?",
        "Confirmation",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning",
        },
      );
      if (!confirmed) return;

      try {
        this.setLoading = true;
        await GoodsInReviewService.completeGoodsIn(e.Code);
        this.$notify(
          "Goods In marked as Completed. Accrual reversal journal processed.",
          "success",
        );
        this.$nextTick(() => {
          this.setLoading = false;
          if (grid) {
            grid.refresh(true);
          }
        });
      } catch (error) {
        this.setLoading = false;
      }
    },
    rowClickCallBack(e) {
      if (
        e.rowType === "data" &&
        e.column.screenField !== "OrderStatus" &&
        e.column.screenField !== "GridRecordEmail" &&
        e.column.screenField !== "GridRecordPDFView" &&
        e.column.screenField !== "GridRecordPrint" &&
        e.column.screenField !== "GridRecordEllipsisMenu" &&
        e.column.screenField !== "PurchaseOrder"
      ) {
        this.onRowClicked(e, {
          view: this,
          page: "goods-in-review",
          mode: "review",
          idProperty: "Code",
        });
      }
    },
  },

  created() {},
};
</script>

<style lang="scss"></style>
